// 一些不需要做权限控制的内页（不受权限控制）
import * as COM from '../components';
const noAuthRouter = [
  /** ------------------------------ 一级页面 ------------------------------ */
  {
    path: '/delivery-management/list/success',
    component: COM.Layout,
    redirect: '/delivery-management/list/success',
    name: 'market__engine_noAuth',
    meta: { label: '营销引擎' },
    /** ------------------------------ 二级页面 ------------------------------ */
    children: [
      { path: '/delivery-management/list/success',
        redirect: '/delivery-management/list/success',
        meta: { label: '精准投放管理', insidePageFrom: 'deliveryManagementList' },
        components: {
          bodyView: COM.DetailLayout,
          appHeader: COM.NavHeader,
          bodyHeader: COM.BodyHeader,
          secondMenu: COM.SecondMenu
        },
        name: 'audienceListNoAuth',
        children: [
          {
            path: '/delivery-management/list/success',
            icon: 'el-icon-document',
            components: {
              bodyView: COM.DeliveryManagementSuccess,
            },
            name: 'deliveryManagementSuccess',
            meta: { label: '投放详情', icon: 'el-icon-document', menuKeyPath: '/delivery-management/list', authKey: 'deliveryManagementList' },
          }
        ]
      }
    ]
  }
];
export default noAuthRouter;
